import { useTranslation } from "react-i18next";

import { useStartNewSession } from "features/Home/StartNewSession/useStartNewSession";

import Button from "components/Button";

export default function StartNewSession() {
  const { t } = useTranslation();
  const { handleCreateNewSession } = useStartNewSession();

  return (
    <div className="flex flex-col gap-4 p-4 bg-general-mint-600 rounded-lg">
      <p className="text-lg font-semibold text-center">{t("home.dashboard.newSession")}</p>
      <Button variant="primary" onClick={handleCreateNewSession}>
        {t("home.dashboard.start")}
      </Button>
    </div>
  );
}
